import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const getWrapperStyles: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	backgroundColor: 'backgrounds.dark',
	width: '100%',
};

export const getContentWrapperStyles = (showContactLink: boolean): SxProps<Theme> => ({
	maxWidth: '1920px',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: showContactLink ? '2.75rem' : '0rem',
	padding: {
		xs: '1.375rem 1.25rem 1rem 1.25rem',
		md: '2.5rem 2% 1rem 2%',
		lg: '2.5rem 5% 1rem 5%',
	},
});

export const contactUsWrapper: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	gap: '0.5rem',
};

export const getAboutWrapperStyles = (showContactLink: boolean): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	color: 'neutrals.white',
	fontSize: { xs: '0.875rem', md: '1.375rem' },
	paddingTop: showContactLink ? '0rem' : '2rem',
	textDecoration: 'none',
	flexDirection: 'column',
	gap: 0,
});

export const getNavWrapperStyles: SxProps<Theme> = {
	display: 'grid',
	width: '100%',
	gridColumnGap: '1.25rem',
	overflow: 'hidden',
};

export const getScheduleContainerStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: { xs: 'column', md: 'row' },
	gap: { xs: '1rem', md: '3rem' },
};

export const footerLinkTextBoxDesktopStyles: SxProps<Theme> = {
	display: 'flex',
	flexWrap: 'nowrap',
	justifyContent: 'flex-start',
	alignItems: 'center',
	whiteSpace: 'nowrap',
};

export const copyrightStyles: SxProps<Theme> = { textAlign: 'center', justifyContent: 'center', display: 'flex' };
